<template>
  <div class="white-container newProductPriority-page flex">
    <el-form ref="form" class="my-form" :model="form" :rules="rules" label-width="120px" size="small">
      <el-form-item label="新品购买时间" prop="startTime" style="width: 279px">
        <el-date-picker v-model="form.startTime" type="datetime" placeholder="优先购开始时间" prefix-icon="el-icon-date" class="custom-date" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOption" :disabled="readOnly === '1'" />
      </el-form-item>
      <el-form-item label="卡片背景图" prop="imageUrl" class="image-config">
        <div class="flex uploadImg-cont">
          <div v-if="readOnly === '1'">
            <img class="read-img" :src="form.imageUrl" alt="">
          </div>
          <UploadImage v-else :url="form.imageUrl" size-tips="960px*660px" :save-path="savePath " @upload=" uploader" @triggerReg="handleCheckReg" />
        </div>
      </el-form-item>
      <el-form-item label="链接地址" prop="linked">
        <div v-if="readOnly === '1'">{{ form.linked }}</div>
        <el-input v-else v-model="form.linked" class="common-input w-360" placeholder="请输入EC购买链接地址" />
      </el-form-item>
      <el-form-item class="opetare-box flex">
        <div class="flex btns">
          <template v-if="readOnly === '1'">
            <el-button type="primary" @click="back">返回</el-button>
          </template>
          <template v-else>
            <el-button type="info" @click="cancel">取消</el-button>
            <el-button type="primary" @click="submit">保存</el-button>
          </template>

        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { NewProductPriority } from '@/model/Benefits';
import UploadImage from '@/components/UploadImage';
export default {
  components: { UploadImage },
  data() {
    return {
      id: undefined,
      readOnly: undefined,
      form: new NewProductPriority(),
      pickerOption: {
        disabledDate: (time) => {
          return Date.now() - 3600 * 1000 * 24 > time.getTime();
        },
      },
      rules: {
        startTime: { required: true, message: "请选择优先购开始时间", trigger: ["blur", "change"] },
        imageUrl: {
          required: true, validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(`请上传卡片背景图`));
            }
            callback();
          }, trigger: ['change'],
        },
        linked: { required: true, message: "请输入EC购买链接地址", trigger: ["blur", "change"] },
      },
      savePath: 'member/newProductPriority/',
    };
  },
  mounted() {
    const { query } = this.$route;
    if (query.id) {
      this.id = +query.id;
      this.fetchData();
    }
    if (query.readOnly) {
      this.readOnly = query.readOnly;
    }
  },
  methods: {
    fetchData() {
      const obj = {
        type: 1,
        newProductPriority: {},
        id: this.id,
      };
      this.$Api.benefits.query(obj).then(res => {
        if (res?.newProductPriority?.length) {
          const data = res.newProductPriority.find(item => item.id === this.id);
          if (!data) return;
          this.form = new NewProductPriority(data);
        }
      });
    },
    uploader(file) {
      this.form.imageUrl = file;
    },
    handleCheckReg() {
      this.$refs.form.validateField("imageUrl");
    },
    cancel() {
      this.$router.push({ path: '/member/benefits' });
    },
    submit() {
      const str = this.id ? '编辑成功' : '新增成功';
      const api = this.id ? this.$Api.benefits.update : this.$Api.benefits.add;
      const obj = { type: 1, newProductPriority: this.form };
      api(obj).then(res => {
        this.$message.success(str);
        setTimeout(() => {
          this.back();
        }, 1500);
      });
    },
    back() {
      this.$router.push({ path: '/member/benefits' });
    },
  },
};
</script>

<style lang="less" scoped>
.newProductPriority-page {
  min-height: calc(100vh - 178px);
  .w-360 {
    width: 360px !important;
  }
  :deep(.custom-date) {
    width: 172px !important;
  }
  :deep(.common-input) {
    height: 32px !important;

    background: #f7f7f7;

    line-height: 32px !important;
    input {
      height: 32px !important;

      line-height: 32px !important;
    }
    :deep(.el-input__inner) {
      &::placeholder {
        color: #bbbbbb;
      }
    }
    &.underline {
      .el-input__inner {
        text-decoration: underline;
      }
    }
    .el-input__inner {
      color: #494949;
    }
  }
  :deep(.el-input.is-disabled) {
    .el-input__icon {
      cursor: unset;
    }
    .el-input__inner {
      cursor: unset;

      color: #494949;
      border-color: #fff;
      background: #fff;
    }
  }
  .my-form {
    display: flex;
    flex: 1;
    flex-direction: column;
    .read-img {
      width: 218px;
      height: 150px;

      border: 1px dashed #e3e3e5;
      border-radius: 16px;
    }
    :deep(.uploader-image) {
      border-radius: 16px;
      div {
        border-radius: 16px;
      }
      .uploader-img {
        width: 218px;
        height: 150px;

        border-radius: 16px;
      }
    }
  }
  .opetare-box {
    align-items: flex-end;
    flex: 1;
    justify-content: center;

    width: 100%;
  }
}
</style>
